export default __webpack_public_path__ + "static/media/featured-one.490aa731.png";